<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                      <div class="row-flex filter-box my-2">
                        <div class="col-flex-2">
                          <ng-select [items]="keywords_list" bindLabel="name" bindValue="id" [closeOnSelect]="false" placeholder="Select Keyword"
                            [(ngModel)]="selected_keyword" [ngModelOptions]="{ standalone: true }" (change)="getKeywordId($event)">
                          </ng-select>
                        </div>
                      </div>
                  </div>
  
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex search-container">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search keyword" #name (keydown.enter)="search(searchVal)"
                          [(ngModel)]="searchVal" />
                        <button class="btn search-btn glow position-absolute"
                          (click)="search(searchVal)">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                          Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/assets/add" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                      <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Digital
                        Guideline</button>
                  </div>
                  <div class="col-12 col-md-8">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="pagedRows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.offset" (page)="onPage($event)">
                    </ngx-datatable>
                  </div>
                </div>
              </fieldset>
             
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [rows]="pagedRows" [limit]="limitRef"  [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages"  [offset]="page.pageNumber - 1"
                (page)="onPage($event)">
                <ngx-datatable-column name="Name" prop="name" [width]="80" [cellClass]="'leftAlign'">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      {{row?.name}}                      
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Count" prop="count" [width]="20" [cellClass]="'leftAlign'">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center cursor-pointer" (click)="goto(row)">
                      {{row?.count}}                      
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Keyword Type" prop="keyword_type" [width]="20" [cellClass]="'leftAlign'">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      {{row?.keyword_type}}                      
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column name="Type" prop="type" [width]="20" [cellClass]="'leftAlign'">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      <div class="d-flex align-items-center">
                        {{row?.type}}                      
                      </div>
                    </ng-template>
                  </ngx-datatable-column> -->
               
                <ngx-datatable-column name="Actions">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i  mat-button [matMenuTriggerFor]="menu" *ngIf="user_role.roles=='admin' || empType.includes('Managment')"
                      class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                      <mat-menu #menu="matMenu">
                          
                        <button *ngIf="user_role.roles=='admin' || empType.includes('Managment')"  mat-menu-item (click)="confirmUpdate(row._id,'update')"><span><i   class="ft-edit text-primary cursor-pointer mx-1" ></i></span>Edit</button> 
                        <button *ngIf="user_role.roles =='admin'"  mat-menu-item (click)="ConfirmColor(row._id)"><span><i  class="ft-trash-2 cursor-pointer danger mx-1"
                          ></i></span>Delete</button> 
                        <button  mat-menu-item (click)="openModal(myModalNotesAdminNotes,row)"> <span><i class="ft-settings text-primary cursor-pointer mx-1"	></i></span> View Notes </button> 
                        <button mat-menu-item (click)="openModalForReplaceKeyword(replaceKeywordModal,row)"><span><i class="ft-settings text-primary cursor-pointer mx-1"	></i></span> Merge Keyword</button>
                      </mat-menu>
                   
                    <i class="ft-copy primary cursor-pointer mx-1" (click)="copyItem(row._id)"></i>
                  </ng-template>
                </ngx-datatable-column> 
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div> 
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>
  
  <!------------- Info Popup --------------------------------------->
  <div>
    <ng-template #infoModal>
      <div class="modal-header">
        <div class="d-flex align-items-center">
          <!-- Display the type with a custom chip -->
          <span *ngIf="current_data?.type" class="type-chip bg-light-info mr-1">
            Type:<span class="bg-light-primary badge badge-pill m-1 text-uppercase">{{ current_data?.type | titlecase }}</span> 
          </span>
        
          <!-- Loop through each domain in current_data and display it -->
            <span *ngIf="current_data?.domain?.length>0" class="type-chip bg-light-secondary domain-chip mr-1">
              Domains:<span  *ngFor="let item of current_data?.domain;let i = index" class="bg-light-primary badge badge-pill m-1">{{ item?.displayname }}</span>
            </span>
        </div>
        
        
        <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table>
          <tr *ngIf="!modal_prop">
            <td class="title"><b><h4>{{current_data?.name}} <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')"><i class="fa fa-edit cursor-pointer ml-3" (click)="editItem(current_data._id,current_data.name,'name')"></i> <span placement="top" ngbTooltip="copy url"><i class="ft-copy cursor-pointer ml-3" (click)="copyItem(current_data._id)"></i></span></span></h4></b>
              
              <span *ngFor="let item of current_data?.category">
                <span class="type-chip bg-light-primary badge badge-pill">{{item.name | titlecase}}</span>
              </span>
              
          </td>
          <div *ngIf="isUpdateName">
            <input type="text" class="form-control" [(ngModel)]="updated_data" [ngModelOptions]="{ standalone: true }" >
            <button class="btn btn-primary mt-1" (click)="update('name')">Update</button>
          </div>
          </tr>
          <!-- <tr>
            <td class="heading"><b>Type</b> <br>
              <span class="ml-3">{{current_data?.type}}</span>
            </td>
          </tr> -->
          <tr *ngIf="!modal_prop">
            <td class="d-flex justify-content-between">
              <span class="ml-3" [innerHTML]="current_data?.notes"></span> 
              <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')"  class="ml-2"><i class="fa fa-edit cursor-pointer"  (click)="editItem(current_data._id,current_data.notes,'notes')"></i></span>
            </td>
          </tr>
          <div *ngIf="isUpdateNotes">
            <quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="notes($event)" [(ngModel)]="updated_data"
              [ngModelOptions]="{ standalone: true }">
            </quill-editor>
            <button class="btn btn-primary mt-1" (click)="update('notes')">Update</button>
          </div>
         
          <tr *ngIf="modal_prop == 'skill' || !modal_prop">
            <td *ngIf="!isUpdateSkills"  class="heading"><b>Skill Keywords :</b> <span class="keyword-buttons">
                 <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')"   class="mx-2 my-1"><i class="fa fa-edit cursor-pointer" (click)="editItem(current_data._id,current_data.skill_keywords,'skill')"></i></span> <br>
              <span   class="collapse-content mt-3 ml-3">
                <span *ngFor="let skill of current_data?.skill_keywords; last as isLast">
                  <span class="bg-light-info badge badge-pill mr-1 mb-1">{{skill}}</span>
                </span>
              </span>
            </span></td>
  
            <div *ngIf="isUpdateSkills">
              <label>Skill Keywords</label>
              <div class="chip-container">
                <span class="chip" *ngFor="let keyword of skill_keywords; let i = index">
                  {{ keyword }}
                  <button class="close-btn" (click)="removeKeyword(i, 'skill')">x</button>
                </span>
                <div class="input-group">
                  <input #skillInput type="text"  (keydown.enter)="$event.preventDefault()" class="skill form-control border-0" placeholder="Add a skill keyword" />
                  <button  class="btn  m-1" (click)="isUpdateSkills=!isUpdateSkills">Cancel</button>
                  <button  class="btn btn-primary m-1" (click)="addKeyword(skillInput.value, 'skill'); skillInput.value=''">Update</button>
                </div>
              </div>
            </div>
          </tr>
          
          <tr *ngIf="modal_prop == 'feature' || !modal_prop">
            <td *ngIf="!isUpdateFeatures" class="heading"><b>Features Keywords :</b> <span class="keyword-buttons">
                <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')" class="mx-2 my-1"><i class="fa fa-edit cursor-pointer"
                    (click)="editItem(current_data._id,current_data.features_keywords,'feature')"></i>
                </span> <br>
              <span class="collapse-content mt-3  ml-3">
                <span *ngFor="let feature of current_data?.features_keywords; last as isLast">
                  <span class="bg-light-warning badge badge-pill mr-1 mb-1">{{feature}}</span>
                </span>
              </span>
            </span></td>
            
            <div *ngIf="isUpdateFeatures">
              <label>Feature Keywords</label>
              <div class="chip-container">
                <span class="chip" *ngFor="let keyword of features_keywords; let i = index">
                  {{ keyword }}
                  <button class="close-btn" (click)="removeKeyword(i, 'feature')">x</button>
                </span>
                <div class="input-group">
                  <input #featureInput type="text"  (keydown.enter)="$event.preventDefault()" class="features form-control border-0" placeholder="Add a feature keyword" />
                  <button  class="btn  m-1" (click)="isUpdateFeatures=!isUpdateFeatures">Cancel</button>
                  <button class="btn btn-primary m-1" (click)="addKeyword(featureInput.value, 'feature'); featureInput.value=''">Update</button>
                </div>
              </div>
            </div>
            
          </tr>
          <tr *ngIf="modal_prop == 'project' || !modal_prop">
            <td *ngIf="!isUpdateProjects" class="heading"><b>Projects Keywords :</b> <span class="keyword-buttons">
                <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')" class="mx-2 my-1"><i class="fa fa-edit cursor-pointer"
                    (click)="editItem(current_data._id,current_data.projects_keywords,'project')"></i>
                </span> <br>
              <span class="collapse-content mt-3  ml-3">
                <span *ngFor="let project of current_data?.projects_keywords; last as isLast">
                  <span class="bg-light-secondary badge badge-pill mr-1 mb-1">{{project}}</span>
                </span>
              </span>
            </span></td>
            <div *ngIf="isUpdateProjects">
              <label>Project Keywords</label>
              <div class="chip-container">
                <span class="chip" *ngFor="let keyword of projects_keywords; let i = index">
                  {{ keyword }}
                  <button class="close-btn" (click)="removeKeyword(i,'project')">x</button>
                </span>
                <div class="input-group">
                  <input #projectInput type="text"  (keydown.enter)="$event.preventDefault()" class="projects form-control border-0" placeholder="Add a Project keyword"/>
                  <button  class="btn  m-1" (click)="isUpdateProjects=!isUpdateProjects">Cancel</button>
                  <button  class="btn btn-primary m-1" (click)="addKeyword(projectInput.value, 'project'); projectInput.value=''">Update</button>
                </div>
              </div>
            </div>
          </tr>     
        </table>
      </div>
  
    </ng-template>
  
  </div>
  
  
  <!------------- Notes And Admin Notes Popup ------------------------>
  <div>
    <ng-template #myModalNotesAdminNotes>
      <div class="modal-header">
        <h4 class="modal-title">{{current_row?.name}}'s Notes & Admin Notes</h4>
        <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <h5>Notes :</h5>
          <p [innerHTML]="current_row?.notes"></p>
        </div>
        <div class="form-group">
          <h5>Admin Notes :</h5>
          <p [innerHTML]="current_row?.admin_notes"></p>
        </div>
      </div>
     
    </ng-template>
  </div>
 <!------------- Replace Keyword Popup ------------------------>
 <div>
  <ng-template #replaceKeywordModal>
    <div class="modal-header">
      <h4 class="modal-title">{{row_data?.name}}'s Merge Keyword</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Old Keyword</label>
        <input type="text" class="form-control" [(ngModel)]="row_data.name" placeholder="Enter old keyword">
      </div>
      <div class="form-group">
        <label>New Keyword</label>
        <ng-select [items]="all_keywords" bindLabel="name" [closeOnSelect]="false" placeholder="Select Keyword"
          [(ngModel)]="selected_new_keyword" [ngModelOptions]="{ standalone: true }" (change)="getNewKeywordId($event)"
          [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
        </ng-select>
        <!-- <input type="text" class="form-control" [(ngModel)]="new_keyword" placeholder="Enter new keyword"> -->
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary mx-1" (click)="modalService.dismissAll()">Cancel</button>
      <button class="btn btn-primary mx-1" (click)="replaceAssetKeyword()">Submit</button>

    </div>
   
  </ng-template>
</div>
